import TotalBudget from './TotalBudget'

export default TotalBudget
